import React from 'react';
import BreadcrumbContainer from 'components/breadcrumb_container';
import Inspections from 'components/inspection/related_inspections_index';
import ShowQuery from 'queries/inspection/show';
import ShowItem from 'components/inspection/show_item';
import Loader from 'components/loader';
import Container from 'components/layout/container';
import { useQuery } from '@apollo/client/react';
import { useParams, useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { PaginateProvider } from 'contexts/paginate';
import { InspectionsLink } from 'utils/link';
import { useError } from 'contexts/error';
import { BreadCrumbLink } from 'components/styles_components/link';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { Typography } from 'components/ui';
import { WhiteCard } from 'components/styles_components/card';

const Inspection = () => {
  const setError = useError();
  const navigate = useNavigate();
  const { inspectionId } = useParams();
  const {
    data = { inspection: { inspectionFields: [], relatedInspectionsTotal: 0 }, space: {} },
    loading,
    error,
    refetch,
  } = useQuery(ShowQuery, {
    variables: { id: inspectionId },
    onError: () => {
      setError('error.inspection.show');
      navigate(InspectionsLink());
    },
  });

  if (loading || error) {
    return <Loader />;
  }

  return (
    <Container>
      <BreadcrumbContainer>
        <BreadCrumbLink to={InspectionsLink()}>
          <FormattedMessage id="breadcrumb.inspections.index" />
        </BreadCrumbLink>
        <BreadCrumbTypography>{data.inspection.name}</BreadCrumbTypography>
      </BreadcrumbContainer>

      <ShowItem inspection={data.inspection} space={data.space} refetch={refetch} />
      {data.inspection.relatedInspectionsTotal > 0 && (
        <WhiteCard>
          <PaginateProvider>
            <Typography variant="h5">
              <FormattedMessage id="inspection.related" />
            </Typography>
            <Inspections
              parentInspectionStatus={data.inspection.status}
              id={inspectionId}
              identifier={data.inspection.identifier}
            />
          </PaginateProvider>
        </WhiteCard>
      )}
    </Container>
  );
};

export default Inspection;
